import { useTranslation } from 'react-i18next';
import type { ILocationProductivityRow } from '@interfaces/IProductivity';
import { formatNumber } from '@utils/formatNumber';
import { formatPercentCell } from '../../../../utils/formatPercent';
import drawerText from '@components/ui/Drawer/drawerContent.module.css';
import styles from './DrillDownFigures.module.css';

interface IDrillDownFiguresProps {
  row: ILocationProductivityRow;
}

/** The floor's figures as a grid of small tiles — the same five numbers the
 *  row carries, each with its own label. */
export function DrillDownFigures({ row }: IDrillDownFiguresProps) {
  const { t } = useTranslation();
  const tiles: { key: string; value: string; wide?: boolean }[] = [
    { key: 'productivity', value: formatPercentCell(row.productivity), wide: true },
    { key: 'spi', value: formatPercentCell(row.spi) },
    { key: 'util', value: formatPercentCell(row.util) },
    { key: 'earnedWorkDays', value: formatNumber(row.earnedWorkDays) },
    { key: 'actualWorkDays', value: formatNumber(row.actualWorkDays) },
  ];
  return (
    <div className={styles.grid}>
      {tiles.map((tile) => (
        <div key={tile.key} className={styles.tile} data-wide={tile.wide ? 'true' : undefined}>
          <span className={drawerText.eyebrow}>{t(`productivity.drillDown.fields.${tile.key}`)}</span>
          <span className={styles.value} data-key={tile.key}>{tile.value}</span>
        </div>
      ))}
    </div>
  );
}
